import { FileRejection, useDropzone } from 'react-dropzone';
import { Text, Flex } from '@mantine/core';
import { TbUpload } from 'react-icons/tb';
import { DropZoneBox } from './style';
import { SPREADSHEET_DROPZONE_ACCEPT } from '../../consts/fileTypes';
import React from 'react';

interface DropZoneProps {
  onDrop: (acceptedFiles: File[], rejectedFiles: FileRejection[]) => void;
  children?: React.ReactNode;
  disabled?: boolean;
  variant?: string;
  dragLabel?: string;
  borderless?: boolean;
  disableClick?: boolean;
  accept?: Record<string, string[]>;
}

export const DropZone = ({
  onDrop,
  children,
  disabled,
  variant = 'default',
  dragLabel = 'Drop files to upload',
  borderless = false,
  disableClick = false,
  accept = SPREADSHEET_DROPZONE_ACCEPT
}: DropZoneProps) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    disabled,
    noClick: disableClick,
    accept
  });

  const supportedFileTypesLabel = accept?.['application/pdf']
    ? 'CSV, XLSX, XLS, XLSM, PDF files supported'
    : 'CSV, XLSX, XLS, XLSM files supported';

  return (
    // @ts-ignore
    <DropZoneBox
      {...getRootProps()}
      isDragActive={isDragActive}
      disabled={disabled}
      variant={variant}
      borderless={borderless}
      className={isDragActive ? 'active' : ''}
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <Text fz="12px" c="#2f6fe4" fw={600}>
          {dragLabel}
        </Text>
      ) : (
        children || (
          <Flex direction="column" align="center" gap="8px">
            <TbUpload size={32} color="#276ef1" />
            <Text fw={500} c="#000">
              Drag files here or click to browse
            </Text>
            <Text fz="12px" c="#868E96">
              {supportedFileTypesLabel}
            </Text>
          </Flex>
        )
      )}
    </DropZoneBox>
  );
};
